import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryInjectiveAddress extends BaseWasmQuery {
    toPayload() {
        return toBase64({
            address: {
                node: this.params.node,
            },
        });
    }
}
